"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Assigned To",
      prop: "assignedTo"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select User"
    },
    model: {
      value: _vm.formData.assignedTo,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "assignedTo", $$v);
      },
      expression: "formData.assignedTo"
    }
  }, _vm._l(_vm.adminList, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Assigned Date",
      prop: "assignedDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.formData.assignedDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "assignedDate", $$v);
      },
      expression: "formData.assignedDate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Due Date",
      prop: "dueDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    on: {
      change: _vm.validateDueDate
    },
    model: {
      value: _vm.formData.dueDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dueDate", $$v);
      },
      expression: "formData.dueDate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Agenda",
      prop: "agenda"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "ex: Call"
    },
    model: {
      value: _vm.formData.agenda,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "agenda", $$v);
      },
      expression: "formData.agenda"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Comments",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      placeholder: "enter your comments.."
    },
    model: {
      value: _vm.formData.comments,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "comments", $$v);
      },
      expression: "formData.comments"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Priority"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select Priority"
    },
    model: {
      value: _vm.formData.priority,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "priority", $$v);
      },
      expression: "formData.priority"
    }
  }, _vm._l(["low", "medium", "high"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Notify Client",
      prop: "notifyClient"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.notifyClient,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "notifyClient", $$v);
      },
      expression: "formData.notifyClient"
    }
  })], 1), _vm.formData.notifyClient ? _c("el-form-item", {
    attrs: {
      label: "Duration of Reminder",
      prop: "reminderDuration"
    }
  }, [_c("el-input-number", {
    attrs: {
      step: 5,
      "step-strictly": "",
      min: 5,
      max: 60
    },
    model: {
      value: _vm.formData.reminderDuration,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "reminderDuration", $$v);
      },
      expression: "formData.reminderDuration"
    }
  }), _c("span", [_vm._v(" (in mins)")])], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Is Next Followup Required",
      prop: "isNextFollowupRequired"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isNextFollowupRequired,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isNextFollowupRequired", $$v);
      },
      expression: "formData.isNextFollowupRequired"
    }
  })], 1), _vm.formData.isNextFollowupRequired ? _c("el-form-item", {
    attrs: {
      label: "Next Followup Set For",
      prop: "nextFollowupAssignedTo"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select User"
    },
    model: {
      value: _vm.formData.nextFollowupAssignedTo,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextFollowupAssignedTo", $$v);
      },
      expression: "formData.nextFollowupAssignedTo"
    }
  }, _vm._l(_vm.adminList, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.isNextFollowupRequired ? _c("el-form-item", {
    attrs: {
      label: "Next Followup Date",
      prop: "nextFollowupAssignedDate"
    },
    model: {
      value: _vm.formData.nextFollowupAssignedDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextFollowupAssignedDate", $$v);
      },
      expression: "formData.nextFollowupAssignedDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.formData.nextFollowupAssignedDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextFollowupAssignedDate", $$v);
      },
      expression: "formData.nextFollowupAssignedDate"
    }
  })], 1) : _vm._e(), _vm.formData.isNextFollowupRequired ? _c("el-form-item", {
    attrs: {
      label: "Next Followup Due Date",
      prop: "nextFollowupDueDate"
    },
    model: {
      value: _vm.formData.nextFollowupDueDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextFollowupDueDate", $$v);
      },
      expression: "formData.nextFollowupDueDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      format: "dd-MM-yyyy",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: _vm.formData.nextFollowupDueDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextFollowupDueDate", $$v);
      },
      expression: "formData.nextFollowupDueDate"
    }
  })], 1) : _vm._e(), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;